import './modules/_maps';
import { CLASSES } from './_consts';

document.addEventListener('DOMContentLoaded', () => {

  const $authLinks = $('.js-auth-link');
  $authLinks.on('click', (e) => {
    e.preventDefault();
    const $current = $(e.currentTarget);
    const targetAttr = $current.attr('data-auth-target');
    const $target = $(`[data-auth="${targetAttr}"]`);
    const $auth = $('.auth-block[data-auth]');

    $auth.removeClass(CLASSES.isActive);
    $target.addClass(CLASSES.isActive);
  });
});
